import { ElementViewTemplate, html, slotted } from "@microsoft/fast-element";
import { CheckboxCardOptions, NatGenCheckboxCard } from "./checkbox-card";
import { endSlotTemplate, startSlotTemplate } from "../start-end/start-end";
import { staticallyCompose } from "../../foundation/template-helpers";

export function checkboxCardTemplate<T extends NatGenCheckboxCard>(options: CheckboxCardOptions = null) {
    return html<T>`
    <template
        role="checkbox"
        aria-checked="${x => x.checked}"
        aria-required="${x => x.required}"
        aria-disabled="${x => x.disabled}"
        tabindex="${x => (x.disabled ? null : 0)}"
        @keydown="${(x, c) => x.keydownHandler(c.event as KeyboardEvent)}"
        @keypress="${(x, c) => x.keydownHandler(c.event as KeyboardEvent)}"
        @click="${(x, c) => x.clickHandler(c.event as MouseEvent)}"
    >
        ${startSlotTemplate(options)}

        <label
            part="label"
            class="${x =>
                x.defaultSlottedNodes && x.defaultSlottedNodes.length
                    ? "label"
                    : "label label__hidden"}"
        >
            <slot ${slotted("defaultSlottedNodes")}></slot>
        </label>

        ${endSlotTemplate(options)}

        <div part="control" class="control">
            <slot name="checked-indicator">
                ${staticallyCompose(options.checkedIndicator)}
            </slot>
        </div>
    </template>
    `;
}
